import React,{ useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Container, Drawer, Box, TextField, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { MdOutlineClose, MdOutlineMultipleStop} from "react-icons/md";
import DataTable from '../Tables/DataTable';
import useComunidades from '../../hooks/useComunidades';
import { getEstadosFincas, getServicesPropsGroup, reasignarServicio } from "../../services";
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';

const DrawerChangeEstado = ({anchor, open, setOpen, aaff_id, onSuccess}) => {
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const location = useLocation();
    const {data, loading, fetchData} = useComunidades({aaff_id:aaff_id});
    const [selected, setSelected] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [service, setService] = useState([]);
    const [state, setState] = useState([]);
    const [stateSelected, setStateSelected] = useState(null);
    const [serviceSelected, setServiceSelected] = useState(null);
    const [isSending, setIsSending] = useState(false);
    
    useEffect(() => {
        const loadServices = async () => {
            if (open) {
                const estados  = await getEstadosFincas();
                const servicios = await getServicesPropsGroup();
                const sortedData = estados.sort((a, b) => a.nombre.localeCompare(b.nombre));
                setService(servicios);
                setState(sortedData);
            }
        };
        loadServices();
    }, [open]);

    const clearServiceFilterAndClose = () => {
        setSelected([]);
        setAllSelected(false);
       
        setService([]);
        setStateSelected(null);
        setServiceSelected(null);
     
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('aaff_id');
        
        // Navegar a la misma ruta pero sin el parámetro aaff_id
        navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
        setOpen(false);
    };
    const headersComunidades = [
        {
              id: "nif",
              numeric: false,
              disablePadding: false,
              label: "NIF",
              overrideFunc: (data, row) => (
               
                <Typography style={{ textAlign: 'left'}}>
                {data}
                </Typography>
              )
            },
        {
            id: "razonSocial",
            numeric: false,
            disablePadding: false,
            label: "COMUNIDAD",
            overrideFunc: (data, row) => (
                <Typography style={{ textAlign: 'left'}}>
                    {row?.finca?.razonSocial}
                </Typography>
            )
        },
    ];
    const handleStateChange = (event) => {
        const selected = state.find(s => s.id === event.target.value);
        setStateSelected(selected || null);
    };
    const handleServiceChange = (event) => {
        const selected = service.find(s => s.id === event.target.value);
        setServiceSelected(selected || null);
    };
    const sendData = async () => {
        if (isSending) return;
        setIsSending(true);

        const saleKeyByService = { 1: 'saleCae_id', 2: 'saleLopd_id', 3: 'saleCai_id' };
        const saleKey = saleKeyByService[serviceSelected?.id];

        const selectedSaleIds = data.rows
            .filter(row => allSelected || selected.includes(row.id))
            .map(row => saleKey ? row[saleKey] : null)
            .filter(Boolean);

        const dataToSend = {
            sales: selectedSaleIds,
            serviceGroup_idActual: serviceSelected ? serviceSelected.id : null,
            state_idActual: stateSelected ? stateSelected.id : null,
        };

        try {
            const response = await reasignarServicio(dataToSend);

            if(response && response.status === 200){
                toast.success("Cambio de estado realizado");
                clearServiceFilterAndClose();
                onSuccess?.();
            } else if(response && response.status === 403){
                toast.error("Error en el cambio de estado: no se ha rellenado algún campo o no tiene servicio asociado");
            } else {
                toast.error("Error al realizar el cambio de estado");
            }
        } finally {
            setIsSending(false);
        }
    };
    return ( 
        <>
            <Drawer
                anchor={anchor}
                open={open}
                onClose={() => clearServiceFilterAndClose()}
            >
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'flex-start', 
                    alignItems: 'center',
                    padding: '10px',
                }}>
                    <button 
                        className='btnCloseDrawer' 
                        onClick={() => clearServiceFilterAndClose()}
                        style={{ marginRight: 'auto' }}
                    >
                        <MdOutlineClose size={30} />
                    </button> 
                </div>

                <Container>
                    <h1 style={{ marginBottom: '20px' }}>Reasignar estados</h1>
                    <Box mx={1} display={"flex"} flexDirection={"row"} gap={1} alignItems="center">
                        <FormControl sx={{ minWidth: 250 }}>
                            <InputLabel id="state-label">Estados</InputLabel>
                            <Select
                                labelId="state-label"
                                id="state-select"
                                value={stateSelected?.id || ''}
                                label="Estados"
                                onChange={handleStateChange}
                            >
                                {state
                                .map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {t(`stateNames.${s.nombre}`, s.nombre)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl sx={{ minWidth: 250 }}>
                            <InputLabel id="service-label">Servicios</InputLabel>
                            <Select
                                labelId="service-label"
                                id="service-select"
                                value={serviceSelected?.id || ''}
                                label="Servicios"
                                onChange={handleServiceChange}
                            >
                                {service.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {s.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <button className='bigBtn' onClick={sendData} disabled={isSending}>
                            <MdOutlineMultipleStop /> {isSending ? 'Enviando...' : 'Reasignar'}
                        </button>
                    </Box>
                    <Box mx={1} display={"flex"} flexDirection={"row"} gap={2} alignItems="center" marginTop={2}>
                        Estado seleccionado: <b>{stateSelected ? stateSelected.nombre : "Ninguno"}</b>
                        Servicio seleccionado: <b>{serviceSelected ? serviceSelected.nombre : "Ninguno"}</b>    
                    </Box>
                    <DataTable
                        isLoading={loading}
                        headers={headersComunidades}
                        data={data.rows?.filter(row => !row.isWorkcenter) || []}
                        meta={data.meta}
                        loading={loading}
                        fetcher={fetchData}
                        enableSection={true}
                        setSelected={setSelected}
                        selected={selected}
                        allSelected={allSelected}
                        setAllSelected={setAllSelected}
                    />
                </Container>
            </Drawer>
        </> 
    );
}

export default DrawerChangeEstado;